import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
// 静态枚举
import { sortTypeEnum } from './utils'
import VueI18n from '@/i18n/locale'

// 默认的显示有交互的筛选项值
export const defaultInteractionFilterValues = {
  /** 油站需要字段开始 */
  status: [], // 商机状态
  type: [], // 门店类型 【商圈不传】
  erpStatus: [], // ERP 状态
  bizStatus: [], // 经营状态（上下架状态）
  groupIds: [], // 集团筛选
  brandIds: [], // 品牌筛选
  sortType: 0, // 排序类型：0-默认
  /** 油站需要字段结束 */
  // ----排序信息
}

// 重构的state
export default {
  timestamp: 0,
  geoErr: false, // 获取不到经纬度信息和定位城市
  filterSelectNum: 0, // 筛选项选择了多少条，为了无数据时展示清空筛选项按钮
  otherPageArrStrategyTagId: [], // 其他页面跳转过来的地方设置【业务策略标签】名称
  workbenchTagIdsAndCity: {
    city: [],
    tagIds: [],
  }, // 存储首页点击的数据
  unCompleteShopIds: [], // 点击营销活动要把店铺带入门店页
  showAllDataPop: false, // 是否展示所有营销活动的弹窗
  strategyId: 0, // 记录当前点击的活动类型 0. 营销 1. SME 2.CKA
  loading: true,
  searchNot: false,
  currentTab: 'priorityStore',
  filterValue: {
    requestType: 0, // 1-全部 2-Acq 3-Eng 4-已下架
    // --- 定位关系
    lat: 0,
    lng: 0,
    // --- 城市相关【普通】
    cityId: '', // 城市ID
    countyIds: [], // 商圈集合
    // --- 城市相关【商圈】
    AreaCityId: '', // 城市ID
    AreaAreaIds: [], // 商圈集合
    ...defaultInteractionFilterValues,
  },
  filterOptions: {
    status: [], // 线索主状态
    type: [], // 门店类型
    erpStatus: [], // ERP 状态
    bizStatus: [], // 经营状态
    // --- 外层筛选 ---
    sortType: sortTypeEnum,
    brand: [],
    group: [],
    cityTree: [],
  },
  lists: {
    [TabNames.priority.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.area.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.my.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.all.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
  },
  realTimeData: {
    item: [],
    title: VueI18n.t('Internal_Tools_App_XqAW_HtbS' /** 实时价格 */),
    isStress: true,
    showCompareInfo: false,
  },
  marketPriceData: {
    item: [],
    title: VueI18n.t('Internal_Tools_App2_wNPW_VZxE' /** 市场零售价 */),
    subregion: 0,
    isStress: true,
    showWeekTimePicker: true,
    showCompareInfo: false,
  },
  params: {},
  loadings: {
    price: true,
    operation: true,
    priceChart: true,
    pump: true,
  },
  historyPrice: {},
  operationData: {
    item: [],
    isStress: true,
    showCompareInfo: true,
  },
}
